import { render, staticRenderFns } from "./VityTables.vue?vue&type=template&id=51a9d75f&"
import script from "./VityTables.vue?vue&type=script&lang=js&"
export * from "./VityTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports